export {Tab} from './tab.component';
export {Tabs, Tabs as default} from './tabs.component';

export {TabPanel} from './tab-panel.component';

export {LinksList} from './tabs.component';
export {SidebarTabs} from './tabs.component';
export {ContentTabs} from './tabs.component';
export {SecondaryTabs} from './secondary-tabs.component';
export {TertiaryTabs} from './tertiary-tabs.component';

export {SidebarTab} from './tab.component';
export {LinkTab} from './tab.component';

export {TabsSeparator} from './tabs-separator.component';
export {
    SecondaryTabSeparator,
    SecondaryTabSeparator as TertiaryTabSeparator,
} from './secondary-tabs-separator.component';

export {TabImage} from './components/tab-image';
export {TabBadge} from './components/tab-badge';
export {TabIcon} from './components/tab-icon';

export {useTabs} from './hooks/use-tabs';

export type {DirectionType} from './tabs.component';
export type {SidebarTabProps} from './tab.component';
export type {TabMenuGroup} from './tab.component';
export type {TabMenuItem} from './tab.component';
export type {TabPanelProps} from './tab-panel.component';
export type {TabProps} from './tab.component';
export type {TabsProps} from './tabs.component';
